import * as React from 'react';

import { TaskStateEditorView } from 'src/app/general/user-tasks/parts/task-state.editor';

interface IProps {
	name: string;
	value?: any;
	extraDiscriminator?: (name: string, value: any) => React.ReactElement<any>;
}

const PropertyRouter: React.SFC<IProps> = ({ extraDiscriminator, name, value }) => {
	if (extraDiscriminator) {
		const component = extraDiscriminator(name, value);

		if (component) {
			return component;
		}
	}
	return <div dangerouslySetInnerHTML={{ __html: value }} />;
}

export default PropertyRouter;



// WEBPACK FOOTER //
// ./src/app/general/audit/parts/property-router.tsx